ui-cms-container-group {
  display: block;
  container-type: inline-size;

  .container-group {
    margin-top: $sd-spacing-8;
    display: grid;
    row-gap: $sd-spacing-8;
    /* stylelint-disable-next-line function-no-unknown */
    column-gap: gutter() * 2;

    &--mobile-reverse {
      grid-auto-flow: dense;

      @include breakpoint($medium) {
        grid-auto-flow: unset;
      }
    }

    &--center-content {
      ui-cms-container {
        height: 100%;
      }

      .sd-container {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }

    &--height-equalized {
      ui-cms-container {
        height: 100%;
      }

      .sd-container {
        height: 100%;
      }
    }

    &--2,
    &--3,
    &--4 {
      grid-template-columns: repeat(1, 1fr);

      @container (min-width: 678px) {
        grid-template-columns: repeat(2, 1fr);
      }
    }

    &--3 {
      @container (min-width: 1053px) {
        grid-template-columns: repeat(3, 1fr);
      }
    }

    &--4 {
      @container (min-width: 1053px) {
        grid-template-columns: repeat(3, 1fr);
      }

      @container (min-width: 1199px) {
        grid-template-columns: repeat(4, 1fr);
      }
    }

    &--2 {
      &.column-distribution--4_8 {
        @container (min-width: 678px) {
          grid-template-columns: 1fr 2fr;
        }
      }

      &.column-distribution--8_4 {
        @container (min-width: 678px) {
          grid-template-columns: 2fr 1fr;
        }
      }
    }
  }
}
